import { createBrowserRouter } from "react-router";
import { Layout } from "./components/Layout";
import { HomePage } from "./components/HomePage";
import { WholesalePage } from "./components/WholesalePage";
import { CheckoutPage } from "./components/CheckoutPage";
import { ConfirmationPage } from "./components/ConfirmationPage";
import { ProductDetailPage } from "./components/ProductDetailPage";
import { JournalPage } from "./components/JournalPage";
import { JournalDetailPage } from "./components/JournalDetailPage";
import { AdminLayout } from "./components/admin/AdminLayout";
import { AdminLoginPage } from "./components/admin/AdminLoginPage";
import { AdminDashboard } from "./components/admin/AdminDashboard";
import { AdminProducts } from "./components/admin/AdminProducts";
import { AdminOrders } from "./components/admin/AdminOrders";
import { AdminSiteConfig } from "./components/admin/AdminSiteConfig";
import { AdminUsers } from "./components/admin/AdminUsers";
import { AdminJournal } from "./components/admin/AdminJournal";
import { AdminPayments } from "./components/admin/AdminPayments";
import { NotFoundPage } from "./components/NotFoundPage";
import { AccountPage } from "./components/AccountPage";
import { RouteErrorPage } from "./components/RouteErrorPage";
import { LegalPage } from "./components/LegalPage";
import { AboutPage } from "./components/AboutPage";
import { ShopPage } from "./components/ShopPage";
import { WorkshopsPage } from "./components/WorkshopsPage";
import { WorkshopReservePage } from "./components/WorkshopReservePage";
import { PoliciesPage } from "./components/PoliciesPage";
import { PressPage } from "./components/PressPage";
import { AdminPressKit } from "./components/admin/AdminPressKit";
import { AdminWholesaleInquiries } from "./components/admin/AdminWholesaleInquiries";
import { AdminWorkshopSessions } from "./components/admin/AdminWorkshopSessions";
import { AdminWorkshopSubscribers } from "./components/admin/AdminWorkshopSubscribers";
import { AdminGdpr } from "./components/admin/AdminGdpr";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Layout,
    errorElement: <RouteErrorPage />,
    children: [
      { index: true, Component: HomePage },
      { path: "shop", Component: ShopPage },
      { path: "product/:slug", Component: ProductDetailPage },
      { path: "workshops", Component: WorkshopsPage },
      { path: "workshops/:sessionId/reserve", Component: WorkshopReservePage },
      { path: "wholesale", Component: WholesalePage },
      { path: "checkout", Component: CheckoutPage },
      { path: "confirmation", Component: ConfirmationPage },
      { path: "journal", Component: JournalPage },
      { path: "journal/:slug", Component: JournalDetailPage },
      { path: "about", Component: AboutPage },
      { path: "press", Component: PressPage },
      { path: "policies", Component: PoliciesPage },
      { path: "legal/:slug", Component: LegalPage },
      { path: "account", Component: AccountPage },
      { path: "*", Component: NotFoundPage },
    ],
  },
  {
    path: "/admin/login",
    Component: AdminLoginPage,
  },
  {
    path: "/admin",
    Component: AdminLayout,
    children: [
      { index: true, Component: AdminDashboard },
      { path: "products", Component: AdminProducts },
      { path: "orders", Component: AdminOrders },
      { path: "wholesale-inquiries", Component: AdminWholesaleInquiries },
      { path: "workshops", Component: AdminWorkshopSessions },
      { path: "workshops/:sessionId/subscribers", Component: AdminWorkshopSubscribers },
      { path: "gdpr", Component: AdminGdpr },
      { path: "site-config", Component: AdminSiteConfig },
      { path: "users", Component: AdminUsers },
      { path: "journal", Component: AdminJournal },
      { path: "press-kit", Component: AdminPressKit },
      { path: "payments", Component: AdminPayments },
    ],
  },
]);
